import { createSlice } from '@reduxjs/toolkit';

import {
	commonReducers,
	CommonState,
	initialCommonState,
} from '../_common/commonReducers';

export interface RequestedMsgFile {
	Id: number;
	RequestedMsgId: number;
	Name: string;
	MediaType: string;
}

export interface RequestedMsg {
	Id: number;
	Status: string;
	Title: string | null;
	Text: string;
	RequestTime: string | null;
	SendThrough: string;
	SendTo: string;
	RequestedBy: string | null;
	ExternalCode: string | null;
	// Server-owned: stamped by the messaging service, never sent on save.
	SendTime: string | null;
	StatusMessage: string | null;
	Files: RequestedMsgFile[];
}

interface RequestedMsgState extends CommonState {}

const initialState: RequestedMsgState = {
	...initialCommonState,
};

const requestedMsgSlice = createSlice({
	name: 'requestedMsg',
	initialState,
	reducers: {
		...commonReducers,
	},
});

export const {
	getTableStart,
	getTableSuccess,
	getTableFailure,
	getTableFinish,

	getItemStart,
	getItemSuccess,
	getItemFailure,

	createItemStart,
	createItemSuccess,
	createItemFailure,
	createItemFinish,

	updateItemStart,
	updateItemSuccess,
	updateItemFailure,
	updateItemFinish,

	deleteItemsStart,
	deleteItemsSuccess,
	deleteItemsFailure,
	deleteItemsFinish,

	deleteItemStart,
	deleteItemSuccess,
	deleteItemFailure,
	deleteItemFinish,

	getTableStructureStart,
	getTableStructureSuccess,
	getTableStructureFailure,

	getItemDocumentsStart,
	getItemDocumentsSuccess,
	getItemDocumentsFailure,
	getItemDocumentsFinish,

	uploadItemDocumentsStart,
	uploadItemDocumentsSuccess,
	uploadItemDocumentsFailure,
	uploadItemDocumentsFinish,

	deleteItemDocumentStart,
	deleteItemDocumentSuccess,
	deleteItemDocumentFailure,
	deleteItemDocumentFinish,

	getTableExcelStart,
	getTableExcelSuccess,
	getTableExcelFailure,
	getTableExcelFinish,
} = requestedMsgSlice.actions;
export default requestedMsgSlice;
